module.exports = __webpack_public_path__ + "img/01_mo.27ff1475.jpg";